import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class ManagementPlanningApi {
    getConfig() {
        const token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    createPlanGest(data) {
        return axios.post(`${URL_API}/cadastro/planejamento-gestao/first`, { ...data, code_access: process.env.APPLICATION_ACCESS }, this.getConfig())
    }

    updatePlanGest(data) {
        return axios.put(`${URL_API}/planejamento-gestao/update`, data, this.getConfig())
    }

    nextPlanGest(data) {
        return axios.put(`${URL_API}/cadastro/planejamento-gestao/next`, data, this.getConfig())
    }

    finishPlanGest(data) {
        return axios.put(`${URL_API}/cadastro/planejamento-gestao/finish`, data, this.getConfig())
    }

    listPlanGest() {
        return axios.get(`${URL_API}/planejamento-gestao`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/management-planning/ManagementPlanningApi.js